// extracted by mini-css-extract-plugin
export default {"wrapper":"presentationBox_wrapper__Kp2vC","imageWrapper":"presentationBox_imageWrapper__y7y5Q","viewLinks":"presentationBox_viewLinks__ZT6F9"};